import { useSidebarHelpers } from '@robovision/rvai-base'
import type { Member } from '~domain/Member'
import EditMemberSidebar from '../components/membersSidebar/EditMemberSidebar.vue'


interface EditMemberSidebarData {
  member?: Member
}

export function useMembersSidebars () {
  const { openSidebar } = useSidebarHelpers()

  function openEditMemberSidebar (data?: EditMemberSidebarData): void {
    openSidebar<string>({
      component: EditMemberSidebar,
      componentProps: {
        member: data?.member,
      },
    })
  }

  return {
    openEditMemberSidebar,
  }
}
